import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { hideAlert } from "../redux/alert/alertActions";
import { useEffect } from "react";
import ConfirmationAlert from "./ConfirmationAlert";
import AlertBox from "./AlertBox";
import { arClass } from "../utils/useArClass";

export const AlertContainer = ({ alertDuration = 4000 }) => {
  const defaultLanguage = useSelector((state) => state.settings.defaultLanguage);
  const alerts = useSelector((state) => state.alerts);
  const darkMode = useSelector((state) => state.settings.darkMode);
  const dispatch = useDispatch();

  useEffect(() => {
    alerts.forEach((alert) => {
      if (alert.type !== "confirmation") {
        const timeoutId = setTimeout(() => {
          dispatch(hideAlert(alert.id));
        }, alertDuration);

        return () => clearTimeout(timeoutId);
      }
    });
  }, [alerts, dispatch, alertDuration]);

  const handleConfirmationConfirm = (alert) => {
    if (alert.onConfirm) {
      alert.onConfirm(alert.rowToDelete);
    }
    dispatch(hideAlert(alert.id));
  };

  const handleConfirmationCancel = (alert) => {
    if (alert.onCancel) {
      alert.onCancel();
    }
    dispatch(hideAlert(alert.id));
  };

  if (alerts.length === 0) {
    return null;
  }

  const defaultlClass = defaultLanguage === "ar" ? "fixed top-4 left-2 z-[10000] w-full max-w-sm flex flex-col gap-3 items-start" : "fixed top-4 right-2 z-[10000] w-full max-w-sm flex flex-col gap-3 items-end";
  
  return (
    <div className={arClass(defaultlClass)}>
      <AnimatePresence>
        <div className={"w-full flex  max-sm:w-[calc(100%-2rem)]"}>
          <div className={arClass("flex flex-col gap-3 w-full")}>
            {alerts.map((alert, index) =>
            alert.type === "confirmation" ? (
              <ConfirmationAlert
                key={alert.id}
                alert={alert}
                message={alert.message}
                onConfirm={() => handleConfirmationConfirm(alert)}
                onCancel={() => handleConfirmationCancel(alert)}
                darkMode={darkMode}
              />
            ) : (
              <AlertBox
                key={alert.id}
                alert={alert}
                index={index}
                darkMode={darkMode}
                alertDuration={alertDuration}
                onClose={() => dispatch(hideAlert(alert.id))}
              />
            )
          )}
          </div>
        </div>
      </AnimatePresence>
    </div>
  );
};